/**
 * Created by hls on 2017/11/22
 * bd基础模块路由.
 */

import _import from './_import_development'

export  default {
  path: '/bd',
  name: 'bd',
  component: _import("Home"),
  meta: {permission: false},
  children: [
    { path: 'InstrumentAdd',component:_import("bd/InstrumentAdd"),name:'仪器编辑'},
    { path: 'InstrumentInfo',component:_import("bd/InstrumentInfo"),name:'仪器详情'},
    { path: 'InstrumentList',component:_import("bd/InstrumentList"),name:'仪器列表'},
    { path: 'TransportList',component:_import("bd/TransportList"),name:'运输设置列表'},
    { path: 'TransportInfo',component:_import("bd/TransportInfo"),name:'运输设置详情'},
    { path: 'TransportAdd',component:_import("bd/TransportAdd"),name:'运输设置编辑'},
    { path:'ProductInfo',component:_import("bd/ProductInfo"),name:'商品详情'},
    { path: 'ProductTree',component:_import("bd/ProductTree"),name:'商品分类列表'},
    { path: 'ProductList',component:_import("bd/ProductList"),name:'商品列表',meta:{ keepAlive:true }},
    { path: 'ProductAdd',component:_import("bd/ProductAdd"),name:'商品编辑'},
    { path: 'ProductNumList',component:_import("bd/ProductNumList"),name:'商品库存列表'},
    { path: 'ProductListNew',component:_import("bd/ProductListNew"),name:'商品列表'},
    { path: 'ProductPackageList',component:_import("bd/ProductPackageList"),name:'商品套餐列表'},
    { path: 'ProductPackageInfo',component:_import("bd/ProductPackageInfo"),name:'商品套餐详情'},
    { path: 'ProductPackageAdd',component:_import("bd/ProductPackageAdd"),name:'商品套餐详情'},
    { path: 'customerType',component:_import("bd/CustomerType"),name:'客户类型'},
    { path: 'customerList',component:_import("bd/CustomerList"),name:'客户列表',meta:{ keepAlive:true } },
    { path: 'customerAuditList',component:_import("bd/CustomerAuditList"),name:'客户审核列表'},
    { path: 'CustomerBusinessAuditList',component:_import("bd/CustomerBusinessAuditList"),name:'商务审核列表'},
    { path: 'customerAdd',component:_import("bd/CustomerAdd"),name:'客户新增'},
    { path: 'customerInfo',component:_import("bd/CustomerInfo"),name:'客户详情'},
    { path: 'customerChangeAdd',component:_import("bd/CustomerChangeAdd"),name:'客户变更新增'},
    { path: 'customerChangeInfo',component:_import("bd/CustomerChangeInfo"),name:'客户变更详情'},
    { path: 'customerMationEdit',component:_import("bd/CustomerMationEdit"),name:'客户信息修改'},
    { path: 'customerMationInfo',component:_import("bd/CustomerMationInfo"),name:'客户信息详情'},

    { path: 'hospitalList',component:_import("bd/HospitalList"),name:'医院列表'},
    { path: 'hospitalAdd',component:_import("bd/HospitalAdd"),name:'医院新增'},
    { path: 'hospitalInfo',component:_import("bd/HospitalInfo"),name:'医院详情'},
    { path: 'ComPanyList',component:_import("bd/ComPanyList"),name:'公司列表'},
    { path: 'ComPanyAdd',component:_import("bd/ComPanyAdd"),name:'公司编辑'},
    { path: 'ComPanyInfo',component:_import("bd/ComPanyInfo"),name:'公司详情 '},
    { path: 'Dictionaryitem',component:_import("bd/Dictionaryitem"),name:'数据字典 '},

    { path: 'DepartmentList',component:_import("bd/DepartmentList"),name:'部门列表'},
    { path: 'DepartmentTree',component:_import("bd/DepartmentTree"),name:'部门树'},
    { path: 'DepartmentInfo',component:_import("bd/DepartmentInfo"),name:'部门详情 '},
    { path: 'EmployeeList',component:_import("bd/EmployeeList"),name:'人员列表',meta:{ keepAlive:true } },
    { path: 'EmployeeAdd',component:_import("bd/EmployeeAdd"),name:'人员新增'},
    { path: 'EmployeeInfo',component:_import("bd/EmployeeInfo"),name:'人员详情'},
    { path: 'CustomerEmployeeList',component:_import("bd/CustomerEmployeeList"),name:'客户人员列表'},
    { path: 'CustomerEmployeeAdd',component:_import("bd/CustomerEmployeeAdd"),name:'客户人员新增'},
    { path: 'CustomerEmployeeInfo',component:_import("bd/CustomerEmployeeInfo"),name:'客户人员详情'},
    { path: 'ProductBatchUpdate',component:_import("bd/ProductBatchUpdate"),name:'批量修改商品价格'},
    { path: 'CustomerBatchAdd',component:_import("bd/CustomerBatchAdd"),name:'批量导入客户'},
    
    //运费规则
    { path: 'RulesList',component:_import("bd/RulesList"),name:'运费规则列表'},
    { path: 'RulesAdd',component:_import("bd/RulesAdd"),name:'运费规则新增'},
    { path: 'RuleslInfo',component:_import("bd/RuleslInfo"),name:'运费规则详情'},

    //审批规则
    { path: 'FlowList',component:_import("flow/FlowList"),name:'审批规则列表'},
    { path: 'FlowAdd',component:_import("flow/FlowAdd"),name:'审批规则新增'},
    { path: 'FlowInfo',component:_import("flow/FlowInfo"),name:'审批规则详情'},
  ]
}



// WEBPACK FOOTER //
// ./src/router/bd.js